export default __webpack_public_path__ + "static/media/6.28b1d059.png";